<template>
  <div class="decoration" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="工地直播" v-if="!isWechatBrowser" :showBack="true"></my-header>

  </div>
</template>
<style lang="scss" scoped>
  @import '../../assets/style/common.scss';
  .decoration{
    background-color: white;
    font-size: 0.36rem;
  }
</style>

<script>
  import EZUIKitJs from "../../components/live/EZUIKitJs";
  import Header from '../../components/header/Header'

  export default {
    name: 'DecoratinoLive',
    components: {
      EZUIKitJs,
      'my-header': Header,
    },
    data () {
      return {
        isWechatBrowser: this.$verfyBrowserType(),
        onestopProjectId: '',
      }
    },
    created(){
      this.onestopProjectId = this.$route.query.onestopProjectId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
    },
    methods: {

    }
  }
</script>

